module.exports = __webpack_public_path__ + "static/media/outline-cloud.468caffa.svg";